import React from 'react'
import { inMillions } from '../../../../../../../utils'

const EMPTY_PLACEHOLDER = '-'

/**
 * Fund Name Custom Cell Component
 * @param data
 * @returns {*}
 */
const FundNameCell = ({ data }) => {
  return (data ? <React.Fragment>
    <i className='ag-react-container-icon ag-react-container-icon--teal q4i-fund-4pt' />{data}
  </React.Fragment> : EMPTY_PLACEHOLDER)
}

/**
 * Updated Date Custom Cell Component
 * @param date
 * @returns {*}
 */
const AddressCell = ({ data }) => {
  const hq = data && data.find((address) => address.hq)
  return hq ? []
    .concat(hq.city, hq.state_province)
    .filter((address) => address && address.trim()).join(', ') : EMPTY_PLACEHOLDER
}

/**
 * AUM Custom Cell Component
 * @param data
 * @param type
 * @returns {*}
 */
const AUMCell = ({ data, type }) => {
  const numberInMillions = data && inMillions(data, 0)
  return <div className={`cell cell--${type}`}>{numberInMillions || EMPTY_PLACEHOLDER}</div>
}

/**
 * Custom Cell Render
 * @param data
 * @param column
 * @returns {*}
 */
const CustomCell = ({ data = {}, column = {} }) => {
  const cellData = data[column.colId]

  switch (column.colId) {
    case 'fund_name':
      return <FundNameCell data={cellData}/>

    case 'address':
      return <AddressCell data={cellData}/>

    case 'style':
      return cellData || EMPTY_PLACEHOLDER

    case 'portfolio_value':
      return <AUMCell data={cellData}/>

    default:
      return EMPTY_PLACEHOLDER
  }
}

export default CustomCell
